export const colors = {
  primary: '#1b5e20',
  primaryLight: '#2e7d32',
  primaryMid: '#388e3c',
  accent: '#4caf50',
  accentLight: '#66bb6a',

  bg: '#f0f7f0',
  bgLight: '#f8fdf8',
  bgCard: '#ffffff',
  bgPage: '#fafaf9',

  border: '#c8e6c9',
  borderLight: '#e8f5e9',
  borderMid: '#a5d6a7',

  textPrimary: '#1a2e1a',
  textSecondary: '#2d4a2d',
  textMuted: '#5a7a5a',
  textLight: '#7a9a7a',
  textOnPrimary: '#ffffff',

  error: '#c62828',
  errorBg: '#ffebee',
  errorBorder: '#ef9a9a',
  warning: '#e65100',
  warningBg: '#fff3e0',
  warningBorder: '#ffe0b2',
  success: '#2e7d32',
  successBg: '#e8f5e9',
  successBorder: '#a5d6a7',
  info: '#1565c0',
  infoBg: '#e3f2fd',

  badgeActive: '#e8f5e9',
  badgeActiveText: '#2e7d32',
  badgeRemoved: '#ffebee',
  badgeRemovedText: '#c62828',
  badgePending: '#fff3e0',
  badgePendingText: '#e65100',
};

export const spacing = {
  xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32, xxxl: 56, xxxxl: 80,
};

export const radius = {
  xs: 4, sm: 8, md: 12, lg: 16, xl: 20, xxl: 28, full: 9999,
};

export const fontSize = {
  xs: '0.7rem',
  sm: '0.8rem',
  base: '0.9rem',
  md: '1rem',
  lg: '1.125rem',
  xl: '1.375rem',
  xxl: '1.75rem',
  hero: '3.5rem',
};

export const shadow = {
  xs: '0 1px 2px rgba(0,0,0,0.05)',
  card: '0 1px 4px rgba(0,0,0,0.06), 0 2px 8px rgba(0,0,0,0.04)',
  elevated: '0 4px 16px rgba(0,0,0,0.10), 0 2px 4px rgba(0,0,0,0.06)',
  hover: '0 8px 28px rgba(27,94,32,0.16), 0 2px 8px rgba(0,0,0,0.06)',
  modal: '0 16px 48px rgba(0,0,0,0.18)',
};

export const transition = {
  fast: 'all 0.15s ease',
  normal: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  slow: 'all 0.3s ease',
};

export const fontFamily = "'Inter', system-ui, -apple-system, sans-serif";

export const inputStyle = {
  width: '100%',
  padding: '13px 16px',
  border: '1.5px solid #c8e6c9',
  borderRadius: 12,
  fontSize: '0.95rem',
  lineHeight: 1.5,
  boxSizing: 'border-box',
  background: '#ffffff',
  WebkitAppearance: 'none',
  outline: 'none',
  transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
  fontFamily: "'Inter', system-ui, sans-serif",
  color: '#1a2e1a',
};

export const labelStyle = {
  fontWeight: 600,
  fontSize: '0.85rem',
  color: '#2d4a2d',
  marginBottom: 6,
  display: 'block',
};

export const btnBase = {
  padding: '14px 28px',
  border: 'none',
  borderRadius: 12,
  fontSize: '0.95rem',
  fontWeight: 700,
  cursor: 'pointer',
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  touchAction: 'manipulation',
  fontFamily: "'Inter', system-ui, sans-serif",
  letterSpacing: '0.01em',
};

export const cardStyle = {
  background: '#ffffff',
  borderRadius: 16,
  padding: 20,
  border: '1px solid #e8f5e9',
  boxShadow: '0 1px 4px rgba(0,0,0,0.06), 0 2px 8px rgba(0,0,0,0.04)',
};
